export default "__VITE_ASSET__DnZVurMp__"